import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiInstance } from '../../axiosApi';

export const auditorListGet = createAsyncThunk('auditor', async (params) => {
  return await apiInstance.get('/auditor', { params });
});

export const auditorOptionsGet = createAsyncThunk('auditor-options', async () => {
  return await apiInstance.get('/auditor');
});

export const auditorReportsGet = createAsyncThunk('admin-audit-report', async (params) => {
  return await apiInstance.get('/admin-audit-report/', { params });
});

export const auditorGetById = createAsyncThunk('auditor/id', async (id) => {
  return await apiInstance.get(`/auditor/${id}`);
});

export const auditorAdd = createAsyncThunk('auditor/add', async (payload) => {
  return await apiInstance.post('/auditor', payload);
});

export const auditorUpdate = createAsyncThunk('auditor/update', async (payload) => {
  const { id, ...rest } = payload;
  return await apiInstance.put(`/auditor/${id}`, rest);
});

export const auditorDelete = createAsyncThunk('auditor/delete', async (id) => {
  return await apiInstance.delete(`/auditor/${id}`);
});

export const auditorCategoryListGet = createAsyncThunk('auditor-categories', async (params) => {
  return await apiInstance.get('/auditor-categories', { params });
});

export const auditorCategoryGetById = createAsyncThunk('auditor-categories/id', async (id) => {
  return await apiInstance.get(`/auditor-categories/${id}`);
});

export const auditorCategoryAdd = createAsyncThunk('auditor-categories/add', async (payload) => {
  return await apiInstance.post('/auditor-categories', payload);
});

export const auditorCategoryUpdate = createAsyncThunk(
  'auditor-categories/update',
  async (payload) => {
    const { id, ...rest } = payload;
    return await apiInstance.put(`/auditor-categories/${id}`, rest);
  }
);

export const auditorCategoryDelete = createAsyncThunk('auditor-categories/delete', async (id) => {
  return await apiInstance.delete(`/auditor-categories/${id}`);
});

export const auditorReportGet = createAsyncThunk('auditReport/list', async (params) => {
  return await apiInstance.get('/auditReport/list', { params });
});

export const auditorReportDetailsGet = createAsyncThunk('auditReport/list-byId', async (params) => {
  return await apiInstance.get(`/auditReport/${params?.call_history_id}`, { params });
});

export const auditorReportAdd = createAsyncThunk('auditReport/add', async (payload) => {
  return await apiInstance.post('/auditReport/', payload);
});

export const manualAuditSubmit = createAsyncThunk(
  'auditReport/auto-audit/audit',
  async (payload) => {
    return await apiInstance.post('/auto-audit/audit', payload);
  }
);

const initialState = {
  auditorList: null,
  auditorCategoryList: null
};

const auditorSlice = createSlice({
  name: 'auditor',
  initialState,
  reducers: {
    clearAuditorSlice: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(auditorListGet.fulfilled, (state, action) => {
      state.auditorList = action?.payload;
    });
    builder.addCase(auditorCategoryListGet.fulfilled, (state, action) => {
      state.auditorCategoryList = action?.payload;
    });
  }
});

export default auditorSlice.reducer;
export const { clearAuditorSlice } = auditorSlice.actions;

export const selectAuditorList = (state) => state.auditor.auditorList;
export const useAuditorList = () => {
  const auditorList = useSelector(selectAuditorList);
  return useMemo(() => auditorList, [auditorList]);
};

export const selectAuditorCategoryList = (state) => state.auditor.auditorCategoryList;
export const useAuditorCategoryList = () => {
  const auditorCategoryList = useSelector(selectAuditorCategoryList);
  return useMemo(() => auditorCategoryList, [auditorCategoryList]);
};
